/** 배우 찾기의 AI 검색에서 쓰는 조각들 — 조건 읽기와 실패 문구 */

export const AI_SEARCH_MAX_QUERY = 2000;

const GENDER_LABEL = { M: '남성', F: '여성', MALE: '남성', FEMALE: '여성' };

/** 서버가 읽어낸 조건 → 화면에 보여줄 "항목: 값" 목록 */
export function conditionRows(conditions) {
  if (!conditions) return [];
  const rows = [];
  if (conditions.gender) rows.push(['성별', GENDER_LABEL[conditions.gender] || conditions.gender]);

  const { ageMin, ageMax, heightMin, heightMax } = conditions;
  if (ageMin != null || ageMax != null) {
    rows.push(['나이', ageMin != null && ageMax != null ? `${ageMin}~${ageMax}세`
      : ageMin != null ? `${ageMin}세 이상` : `${ageMax}세 이하`]);
  }
  if (heightMin != null || heightMax != null) {
    rows.push(['키', heightMin != null && heightMax != null ? `${heightMin}~${heightMax}cm`
      : heightMin != null ? `${heightMin}cm 이상` : `${heightMax}cm 이하`]);
  }
  if (conditions.skillsRequired?.length) rows.push(['필수 조건', conditions.skillsRequired.join(', ')]);
  if (conditions.skillsPreferred?.length) rows.push(['우대 조건', conditions.skillsPreferred.join(', ')]);
  return rows;
}

/** AI 검색 실패 → 화면 문구. showFallback이면 일반 검색으로 나가는 버튼을 함께 보여준다. */
export function describeAiSearchError(err) {
  const status = err?.response?.status;
  const code = err?.response?.data?.code;
  if (status === 400) {
    return {
      title: '공고 내용을 확인해 주세요',
      description: code === 'AI_SEARCH_QUERY_TOO_LONG'
        ? `공고가 너무 길어요. ${AI_SEARCH_MAX_QUERY}자 이내로 줄여서 다시 시도해 주세요.`
        : '찾으시는 배역과 조건을 문장으로 입력해 주세요.',
    };
  }
  if (code === 'AI_SEARCH_PARSE_FAILED') {
    return { title: '공고를 읽는 데 실패했어요', description: '잠시 후 다시 시도해 주세요.' };
  }
  return {
    title: 'AI 검색을 잠시 사용할 수 없어요',
    description: '키워드로 직접 찾아보시거나, 잠시 후 다시 시도해 주세요.',
    showFallback: true,
  };
}
